export const LIMIT_PROMPT_MESSAGES = 10;

export const DEFAULT_PICTURE =
  "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/images%2Fjl-ai.png?alt=media&token=fd49c0d4-2e5c-4fe1-a1b6-833dde5ffc7b";

export const ACTIONS_REWRITE = {
  SUMMARIZATION: "rewrite-summarization",
  SIMPLIFICATION: "rewrite-simplification",
  CLARIFICATION: "rewrite-clarification",
  CONSISTENCY: "rewrite-consistency",
};

export const PROMPTS = {
  "generate-outline": {
    en: `Generate a detailed chapters list for a non-fiction book in the category $category on $idea, using the following format for each chapter and subchapter:

[
{
"name": "CHAPTER_NAME",
"description": "CHAPTER_DESCRIPTION",
"subchapters": [
{ "name": "SUBCHAPTER_NAME", "description": "SUBCHAPTER_DESCRIPTION" }
]
}
]

The book should be aimed at $audience cover key concepts such as $keyConcepts.
The book should be structured as $structure.

The tone should resemble that of $styleAuthors.
The author of this book is called $authorName.

You should have a minimum of 8 chapters and each chapter should have a minimum of 5 subchapters.

DO NOT ADD THE BOOK NAME, BOOK DESCRIPTION OR BOOK AUTHOR. RETURN ONLY THE CHAPTERS IN THE ARRAY.`,
  },
  "improve-outline": {
    en: `Improve that list of chapters for a non-fiction book in the $category category on $idea.

The intended audience is $audience.
The key concepts and themes to be covered in the book include $keyConcepts.
The writing style and tone should be similar to $styleAuthors.

The author of this book is called $authorName.
Here's more about the author:
$authorData

Here is the current outline of the book:
$bookOutline

Please improve that comprehensive list of chapters for the book and add more chapters.

Use the following format for each chapter and subchapter:
[
{
"name": "CHAPTER_NAME",
"description": "CHAPTER_DESCRIPTION",
"subchapters": [
{ "name": "SUBCHAPTER_NAME", "description": "SUBCHAPTER_DESCRIPTION" }
]
}
]`,
  },
  "generate-file": {
    en: `Act as a world class non fiction book writer.
Your job is to write a part of the chapter $chapterIndex of the book called $bookName.

Here's a summary of the book:
The intended audience is $audience.
The key concepts and themes to be covered in the book include $keyConcepts.
Follow the writing style and tone of $styleAuthors.
Here are is the outline of the book:
$bookOutline

The author of this book is called $authorName.
Here's more about the author:
$authorData

The chapter $chapterIndex is called $chapterName and talks about $chapterDescription.

The specific part you're writing about is specifically about $elementDescription.

DO NOT WRITE THE CHAPTER NUMBER OR THE CHAPTER NAME OR THE PART AT THE BEGINNING`,
  },
  "generate-book-name": {
    en: `Act as a world class non fiction book writer.
Write the name of the book.

Here are is the outline of the book:
$bookOutline

Book Name:`,
  },
  [ACTIONS_REWRITE.SUMMARIZATION]: {
    en: `Act as a world class non fiction book writer.
Summarize that text:
$textToRewrite
`,
  },
  [ACTIONS_REWRITE.SIMPLIFICATION]: {
    en: `Act as a world class non fiction book writer.
Simplify that text:
$textToRewrite
`,
  },
  [ACTIONS_REWRITE.CLARIFICATION]: {
    en: `Act as a world class non fiction book writer.
Rewrite that text with more precisions:
$textToRewrite
`,
  },
  [ACTIONS_REWRITE.CONSISTENCY]: {
    en: `Act as a world class non fiction book writer.
Rewrite the text given to be more consistent with the text before and after:

TEXT BEFORE:
$textBefore

TEXT AFTER:
$textAfter

TEXT TO REWRITE:
$textToRewrite
`,
  },
};

[
  {
    name: "CHAPTER_NAME",
    description: "CHAPTER_DESCRIPTION",
    subchapters: [{ name: "SUBCHAPTER_NAME", description: "SUBCHAPTER_DESCRIPTION" }],
  },
];
